import React, { useEffect, useState } from 'react';
import { withStyles } from "@mui/styles";
import { Styles } from "../../../../../config/design/styles";
import {Button, CircularProgress, IconButton, Typography} from "@mui/material";
import { Minus, Plus, PlusCircle, Trash } from "lucide-react";
import { useTranslation } from "react-i18next";
import {connect, setStore} from "trim-redux";
import LoginDialog from "../../components/LoginDialog";
import axios from "axios";
import { defaultVariables } from "../../../../../config";
import { updateRedux } from "../../../../../config/Security";
import clsx from "clsx";
import MultiVendorDialog from "../../components/MultiVendorDialog";
import {enqueueSnackbar} from "notistack";

let debounceTimeout = null; // Global variable for debounce timer

function AddToCartBtn({ product, classes, isAuth, user ,icon, disabled,oos,in_cart,in_card, isRemoved = null}) {
    const { t } = useTranslation();
    const [quantity, setQuantity] = useState(0); // Reflects server state
    const [pendingQuantity, setPendingQuantity] = useState(0); // Tracks user actions
    const [authOpen, setAuthOpen] = useState(false);
    const [multiVendorOpen, setMultiVendorOpen] = useState(false);
    const [plusDisabled, setPlusDisabled] = useState(false);
    const [loading, setLoading] = useState(false);

    const checkQuantity = async () => {
        if(pendingQuantity === quantity){
            if (!!isAuth) {
                const cart = user?.carts?.find(item => item.product_id === product.id);
                if (cart) {
                    setQuantity(cart.quantity);
                    setPendingQuantity(cart.quantity); // Sync with initial server state
    
                } else {
                    setQuantity(0);
                    setPendingQuantity(0);
                }
            } else {
                setQuantity(0);
                setPendingQuantity(0);
            }
        }

    };

    useEffect(() => {
        if (!!isAuth) {
            checkQuantity();
        }
    }, [isAuth, user]);

    useEffect(() => {
        if(product.has_inventory){
            if(product.inventory <= pendingQuantity){
                setPlusDisabled(true)
            }else{
                setPlusDisabled(false)
            }
        }
        if (!!product.purchase_cooldown_days && pendingQuantity >= 1) {
            setPlusDisabled(true);
        }
    }, [pendingQuantity, product]);


    const syncToServer = async (finalQuantity) => {
        setLoading(true);
        const data = new FormData();
        data.append('product_id', product.id);
        data.append('quantity', finalQuantity);
        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`,
            },
        };

        try {
            await axios.post(`${defaultVariables.url}/cart/change`, data, config);

            setQuantity(finalQuantity); // Sync UI with server state
            await updateRedux();
          
        } catch (error) {
            console.error('Error updating server:', error.response || error);
            const message = error?.response?.data?.message;
            if (message) {
                enqueueSnackbar(message, { variant: 'warning' });
            }
            if (error?.response?.data?.purchase_locked) {
                setPendingQuantity(quantity);
            }
        } finally {
            setLoading(false);
        }
    };
    const handleDeleteItem = () => {
        syncToServer(0);
    }
    const handleAddToCart = (e,type = "plus") => {
        setStore({
            cart_loading:true
        })
        e.stopPropagation();
        e.preventDefault();
        if (!!product.purchase_locked) {
            return;
        }
        if (!!isAuth) {
            if(!!user.address){
                if(!!user.cart_shop_id  && user.cart_shop_id !== product.shop_id){
                    setMultiVendorOpen(true);
                }else{
                    let updatedQuantity = pendingQuantity;
                    if (type === "plus") {
                        const maxQty = !!product.purchase_cooldown_days ? 1 : null;
                        if ((!product.has_inventory  || updatedQuantity < product.inventory) && (maxQty === null || updatedQuantity < maxQty)) {
                            updatedQuantity += 1;
                        }
                    } else if (type === "minus" && pendingQuantity > 0) {
                        updatedQuantity -= 1;
                    }
                    setPendingQuantity(updatedQuantity);
                    if(updatedQuantity === 0){
                            if(!!isRemoved){
                                isRemoved();
                            }
                    }
                    // Debounce API calls
                    if (debounceTimeout) {
                        clearTimeout(debounceTimeout);
                    }

                    debounceTimeout = setTimeout(() => {
                        syncToServer(updatedQuantity);
                    }, 600);
                }
            }else{
                setStore({
                    address_dialog:true
                })
            }

        } else {
            setAuthOpen(true);
        }
    };

    return (
        <>
            {
                !!oos ?
                    <div>
                        <Button
                            className={classes.cartRemoveItem}
                            size="small"
                            color="primary"
                            endIcon={<Trash className="trash lucide-small"/>}
                            onClick={(e) => handleDeleteItem()}
                        >
                            {t('outOfStock')}

                        </Button>
                    </div>

                    :
                    <div className={clsx("addToCart",!icon && "expand",pendingQuantity > 0 && "more-quantity",(!!disabled || !!plusDisabled || !!product.purchase_locked) && "disabled")}>
                        {pendingQuantity > 0 ? (
                            <div className="add-to-cart-holder">
                                {
                                    !in_card && 
                                    <div>
                                        {pendingQuantity > 1 ? (
                                            <IconButton disabled={disabled || !!product.purchase_locked} size="small" onClick={(e) => handleAddToCart(e,'minus')}>
                                                <Minus />
                                            </IconButton>
                                        ) : (
                                            <IconButton disabled={disabled || !!product.purchase_locked} size="small" onClick={(e) => handleAddToCart(e,'minus')}>
                                                <Trash className="trash lucide-small-narrow"/>
                                            </IconButton>
                                        )}
                                    </div>
                                }
                               
                                <div key={pendingQuantity} className={`quantity-holder animate`} >{pendingQuantity}</div>
                                {
                                    !in_card &&
                                    <div>
                                        <IconButton disabled={disabled || plusDisabled || !!product.purchase_locked} size="small" onClick={(e) => handleAddToCart(e,'plus')}>
                                            <Plus />
                                        </IconButton>
                                    </div>
                                }
                            </div>
                        ) : (
                            <>
                            {
                                !in_cart && 
                                <>
{
                                    !!icon ?
                                        <IconButton disabled={disabled || plusDisabled || !!product.purchase_locked} onClick={(e) => handleAddToCart(e)} color="secondary" className="plus">
                                            <Plus className="lucide-large" />
                                        </IconButton>
                                        :
                                        <Button
                                            startIcon={<Plus className="lucide-large" />}
                                            variant="contained"
                                            color="secondary"
                                            disabled={disabled || plusDisabled || !!product.purchase_locked}
                                            onClick={(e) => handleAddToCart(e)}
                                        >
                                            {t('addToCart')}
                                        </Button>
                                }

                                </>
                            }
                             
                            </>

                        )}
                    </div>
            }

            <LoginDialog open={authOpen} setOpen={setAuthOpen} />
            <MultiVendorDialog open={multiVendorOpen} setOpen={setMultiVendorOpen} />
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.user,
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(AddToCartBtn));
